import { render, staticRenderFns } from "./FollowTag.vue?vue&type=template&id=ee7582fe&scoped=true"
import script from "./FollowTag.vue?vue&type=script&lang=js"
export * from "./FollowTag.vue?vue&type=script&lang=js"
import style0 from "./FollowTag.vue?vue&type=style&index=0&id=ee7582fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7582fe",
  null
  
)

export default component.exports